var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { VeLine } from "v-charts";
var CaseGroupChart = /** @class */ (function (_super) {
    __extends(CaseGroupChart, _super);
    function CaseGroupChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            overduePeriod: ''
        };
        _this.caseAmountChart = {
            data: {
                columns: ['date', 'goalRate', 'actualRate'],
                rows: new Array()
            },
            setting: {
                metrics: ['goalRate', 'actualRate'],
                dimension: ['date'],
                yAxisName: ['回收率：%'],
                labelMap: {
                    date: '日期',
                    goalRate: '目标回收率',
                    actualRate: '实际回收率',
                }
            }
        };
        return _this;
    }
    CaseGroupChart.prototype.mounted = function () {
        var rows = [];
        for (var i = 1; i < 31; i++) {
            rows.push({ date: '12/' + i, goalRate: 95, actualRate: 87 });
        }
        this.caseAmountChart.data.rows = rows;
    };
    CaseGroupChart = __decorate([
        Component({
            components: {
                VeLine: VeLine
            }
        })
    ], CaseGroupChart);
    return CaseGroupChart;
}(Vue));
export default CaseGroupChart;
